import LinkedEntity from './LinkedEntity';
import TaskImportance from './TaskImportance';
import TaskStatus from './TaskStatus';
import { OwaDate } from 'owa-datetime';
import { getGuid } from 'owa-guid';

/**
 * Todo Item definition: Add properties here from the Task and Item contracts as needed.
 * Mobx has a problem with optionals, so this serves as our wrapper around the todo item contract type
 * and will be what we use in forms such that the contract type is only used in the service layer.
 */
interface Todo {
    Id: string;
    ParentFolderId: string;
    Subject: string;
    IsReminderOn: boolean;
    ReminderDateTime: OwaDate;
    OrderDateTime: OwaDate;
    Importance: TaskImportance;
    CompletedDateTime: OwaDate;
    DueDateTime: OwaDate;
    Status: TaskStatus;
    Note: string;
    LinkedEmail: LinkedEntity;
}

export default Todo;

export function createTodo(partialTodo: Partial<Todo>): Todo {
    partialTodo = partialTodo !== null ? partialTodo : {};

    return {
        ...partialTodo,
        Id: partialTodo.Id ? partialTodo.Id : getGuid(),
        ParentFolderId: partialTodo.ParentFolderId ? partialTodo.ParentFolderId : null,
        Subject: partialTodo.Subject ? partialTodo.Subject : null,
        ReminderDateTime: partialTodo.ReminderDateTime ? partialTodo.ReminderDateTime : null,
        IsReminderOn: partialTodo.IsReminderOn ? partialTodo.IsReminderOn : false,
        CompletedDateTime: partialTodo.CompletedDateTime ? partialTodo.CompletedDateTime : null,
        DueDateTime: partialTodo.DueDateTime ? partialTodo.DueDateTime : null,
        OrderDateTime: partialTodo.OrderDateTime ? partialTodo.OrderDateTime : null,
        Status: partialTodo.Status ? partialTodo.Status : 'NotStarted',
        Importance: partialTodo.Importance ? partialTodo.Importance : TaskImportance.Normal,
        Note: partialTodo.Note ? partialTodo.Note : null,
        LinkedEmail: partialTodo.LinkedEmail ? partialTodo.LinkedEmail : null,
    };
}
